/**
 * @generated SignedSource<<e6cabf9888be380a2c4f46bba1196497>>
 * @relayHash 158887780bd1a61d3dd5797d93e43ed7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID faeadbf50f84351cf8db27c8ad260aa1e495f0867fba2cb82034fa69def18073

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainVirtualServiceAgentCtaCardQuery } from './mainVirtualServiceAgentCtaCardQuery.graphql';

const node: PreloadableConcreteRequest<mainVirtualServiceAgentCtaCardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "faeadbf50f84351cf8db27c8ad260aa1e495f0867fba2cb82034fa69def18073",
    "metadata": {},
    "name": "mainVirtualServiceAgentCtaCardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
